import { AppButton, AppTextField } from 'components';
import ChapterTopicsDropDown from 'components/molecules/ChapterTopicsDropDown';
import ClassSubjectsDropDown from 'components/molecules/ClassSubjectsDropDown';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import ESDropDown from 'components/molecules/ESDropDown';
import QuestionBankCategory from 'components/molecules/QuestionBankCategory';
import SubjectChaptersDropDown from 'components/molecules/SubjectChaptersDropDown';
import useQuizzes from 'hooks/API/GET/useQuizzes';
import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';

import { AiOutlineFileDone } from 'react-icons/ai';
import useDebounce from 'hooks/useDebounce';
import QuizDeleteModal from './manage/Questions/QuizDeleteModal';
import TablePaginate from 'components/Paginate';
import ESTDropDown from 'components/molecules/ESTDropDown';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import * as AppPics from 'assets/images';

function ManageQuiz() {
  const [est, setEST] = useState('');
  const [ES, handleES] = useState('');
  const [ESClass, handleESClass] = useState('');
  const [classSubject, handleClassSubject] = useState('');
  const [subjectChapter, handleSubjectChapter] = useState('');
  const [topic, handleTopic] = useState('');
  const [questionBank, handleQuestionBank] = useState('');
  const [search, handleSearch] = useState('');
  const [deleteQModal, handleDeleteQModal] = useState(Object.assign({}, DELETE_QUIZ_MODAL_CONFIG));
  const [params, setParams] = usePaginateDefaults();

  const searchKeyword = useDebounce(search, 1000);

  function clearFilter() {
    setEST('');
    handleES('');
    handleESClass('');
    handleClassSubject('');
    handleSubjectChapter('');
    handleTopic('');
    handleQuestionBank('');
  }

  // let queryParams = `?est=${est}&es=${ES}&classId=${ESClass}&subjectId=${classSubject}&chapterId=${subjectChapter}&topicId=${topic}&quizCategory=${questionBank}&keyword=${searchKeyword}`;
  const {
    isLoading,
    data: tableData,
    isError,
  } = useQuizzes({
    enabled: true,
    configs: {
      params: {
        ...params,
        est,
        es: ES,
        classId: ESClass,
        subjectId: classSubject,
        chapterId: subjectChapter,
        topicId: topic,
        quizCategory: questionBank,
        keyword: searchKeyword,
      },
    },
  });
  const { meta: { page, total } = {} } = tableData?.data ?? {};
  // @TODO
  // there are certain filters hidden using inline styles and dnone class. this is temporary
  // these fileds are needed, currently hidden becuase its not tested and design is not good
  //
  return (
    <Fragment>
      <QuizDeleteModal
        modalConfig={deleteQModal}
        closeModal={() => handleDeleteQModal(Object.assign({}, DELETE_QUIZ_MODAL_CONFIG))}
      />
      <div className="mainWraper">
        <div className="container-fluid outerborder">
          <div className="row">
            <div className="col-6">
              <h2 className="prime-head p-0">Manage quiz</h2>
              {/* <span></span> */}
            </div>
            <div className="col-6 prime-head text-right">
              <AppButton variantClass="btn-plane p--tint mx-2 dnone" onClick={clearFilter}>
                Clear filter
              </AppButton>
              <Link to="/manage/quiz/add">
                <AppButton variantClass="btn-plane g--tint">+ Add quiz</AppButton>
              </Link>
            </div>
          </div>
          <div className="row mt-4" style={{ display: 'none' }}>
            <div className="col-lg-4 col-md-6 col-sm-12">
              {/* START: "EST" drop down */}
              <ESTDropDown
                enableAPI
                value={est}
                handleChange={(event) => setEST(event.target.value)}
              />
              {/* END: "EST" drop down */}
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              {/* START: "ES" drop down */}
              <ESDropDown
                enableAPI={!!est}
                dependencies={{
                  query: est ? `est=${est}` : ``,
                }}
                value={ES}
                handleChange={(event) => handleES(event.target.value)}
                defaultLook={false}
              />
              {/* END: "ES" drop down */}
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              {/* START: "Class" drop down */}
              <ESClassDropDown
                enableAPI={!!ES}
                dependencies={{
                  query: `esId=${ES}`,
                }}
                value={ESClass}
                handleChange={(event) => handleESClass(event.target.value)}
                defaultLook={false}
              />
              {/* END: "Class" drop down */}
            </div>
          </div>
          <div className="row mb-4" style={{ display: 'none' }}>
            {/* START: "Subjects" drop down */}
            <div className="col-lg-4 col-md-6 col-sm-12">
              <ClassSubjectsDropDown
                enableAPI={!!ESClass}
                dependencies={{
                  query: `esId=${ES}&classId=${ESClass}`,
                }}
                value={classSubject}
                handleChange={(event) => handleClassSubject(event.target.value)}
              />
            </div>
            {/* END: "Subjects" drop down */}
            <div className="col-lg-4 col-md-6 col-sm-12">
              {/* START: "Chapters" drop down */}
              <SubjectChaptersDropDown
                enableAPI={!!classSubject}
                dependencies={{
                  classID: ESClass,
                  subjectID: classSubject,
                }}
                value={subjectChapter}
                handleChange={(event) => handleSubjectChapter(event.target.value)}
              />
              {/* END: "Chapters" drop down */}
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              {/* START: "Topics" drop down */}
              <ChapterTopicsDropDown
                enableAPI={!!subjectChapter}
                dependencies={{
                  classID: ESClass,
                  subjectID: classSubject,
                  chapterID: subjectChapter,
                }}
                value={topic}
                handleChange={(event) => handleTopic(event.target.value)}
              />
              {/* END: "Topics" drop down */}
            </div>
          </div>

          <div className="row mb-4" style={{ display: 'none' }}>
            <div className="col-lg-4 col-md-6 col-sm-12">
              {/* START: "Question Bank Category" drop down */}
              <QuestionBankCategory
                value={questionBank}
                handleChange={(event) => handleQuestionBank(event.target.value)}
              />
              {/* END: "Question Bank Category" drop down */}
            </div>
          </div>

          <div className="d-flex flex-row-reverse" style={{ display: 'none !important' }}>
            <div>
              <AppTextField
                inputProps={{
                  value: search,
                  placeholder: 'Type to search...',
                  onChange: (event) => handleSearch(event.target.value),
                }}
                labelProps={{
                  label: '',
                }}
              />
            </div>
          </div>
          <div className="tableWrap">
            <div className="table-responsive">
              <table className="table tableWrap__table">
                <thead className="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Unique key </th>
                    <th scope="col">Subject</th>
                    <th scope="col">Class</th>
                    <th scope="col">Chapter</th>
                    <th scope="col">Topic</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                {isLoading ? (
                  <tbody>
                    <tr>
                      <td>Loading...</td>
                    </tr>
                  </tbody>
                ) : isError ? (
                  <tbody>
                    <tr>
                      <td>Failed to load data</td>
                    </tr>
                  </tbody>
                ) : tableData?.data?.result?.length > 0 ? (
                  <tbody>
                    {tableData?.data?.result?.map((result, index) => {
                      return (
                        <tr key={result._id}>
                          <th scope="row">{index + 1}</th>
                          <td>{result.name}</td>
                          <td>{result.key}</td>
                          <td>{result?.subject?.name}</td>
                          <td>{result?.class?.name}</td>
                          <td>{result?.chapter?.name}</td>
                          <td>{result?.topic?.name}</td>
                          <td>
                            <Link
                              to={`/manage/topics/${result?.topic?._id}/quiz/${result._id}/questions`}
                              className="actions-icons mx-2 text-success"
                            >
                              <AiOutlineFileDone />
                            </Link>
                            <Link
                              to={`/manage/topics/${result?.topic?._id}/quiz/${result._id}/edit`}
                              className="actions-icons mx-2"
                            >
                              <img src={AppPics.EditSvg} alt="edit this option" />
                            </Link>
                            <AppButton
                              className="actions-icons mx-2 text-danger"
                              onClick={() =>
                                handleDeleteQModal(() => ({
                                  show: true,
                                  data: { topicID: result?.topic?._id, quizID: result._id },
                                }))
                              }
                            >
                              <img src={AppPics.DeleteSvg} alt="delete this option" />
                            </AppButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={8} className="align-center">
                        No records found
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          <TablePaginate
            maxCount={total}
            currentPage={page}
            defaultLimit={params.limit}
            setPage={(page) => setParams((x) => ({ ...x, page }))}
            handleChange={(limit) => setParams((x) => ({ ...x, limit }))}
          />
        </div>
      </div>
    </Fragment>
  );
}

const DELETE_QUIZ_MODAL_CONFIG = {
  show: false,
  data: {
    id: null,
  },
};

export default ManageQuiz;
